import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { EspecialidadeView } from '../../core/_models'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { getEspecialidadeById, updateEspecialidadeStatus } from '../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { EspecialidadeModal } from '../../components/modal/EspecialidadeModal'

type Props = {
  especialidade: EspecialidadeView
}

export const EspecialidadeActionsCell: FC<Props> = ({ especialidade }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = especialidade.nome || 'Especialidade'

  const openEditModal = () =>
    showModal({
      content: <EspecialidadeModal />,
      title: 'Editar Especialidade',
      size: ModalSize.Medium,
      fetchers: {
        especialidade: () => getEspecialidadeById(Number(especialidade.id)),
      },
    })

  const setStatus = async (ativa: boolean) => {
    try {
      showAlertLoading()
      await updateEspecialidadeStatus(especialidade.id, ativa)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi ${ativa ? 'ativada' : 'inativada'}.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  // Inativar pede confirmação explicando a consequência; ativar é reversível e não pede.
  const askInativar = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Inativar especialidade?',
      text: `${nome} deixará de aparecer para novos atendimentos. O histórico continua guardado, e você pode reativá-la quando quiser.`,
      confirmButtonText: 'Inativar',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await setStatus(false)
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Editar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        especialidade.ativa
          ? { label: 'Inativar', onClick: askInativar, danger: true }
          : { label: 'Ativar', onClick: () => setStatus(true) },
      ]}
    />
  )
}
